<template>
  <div class="about-page">
    <section class="hero">
      <div class="container hero-grid">
        <div>
          <p class="eyebrow">About Us</p>
          <h1>{{ texts.hero.title }}</h1>
          <p class="lead">{{ texts.hero.desc }}</p>
        </div>
        <img class="hero-image" :src="officeImage" :alt="texts.hero.alt" />
      </div>
    </section>

    <section class="content">
      <div class="container">
        <div class="about-card">
          <div class="section-header left">
            <h2>{{ texts.companyTitle }}</h2>
            <p>{{ texts.companyDesc1 }}</p>
            <p>{{ texts.companyDesc2 }}</p>
          </div>
          <div class="stats-grid">
            <div v-for="item in texts.stats" :key="item.label" class="stat-item">
              <strong>{{ item.value }}</strong>
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>

        <div class="section-header">
          <h2>{{ texts.productTitle }}</h2>
          <p>{{ texts.productDesc }}</p>
        </div>
        <div class="product-grid">
          <article v-for="item in texts.products" :key="item.title" class="product-card">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
            <a :href="item.href">{{ item.link }}</a>
          </article>
        </div>

        <div class="section-header">
          <h2>{{ texts.valueTitle }}</h2>
        </div>
        <div class="value-grid">
          <article v-for="item in texts.values" :key="item.title" class="value-card">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </article>
        </div>

        <div class="contact-card">
          <h2>{{ texts.contactTitle }}</h2>
          <p>{{ texts.contactAddress }}</p>
          <p>{{ texts.contactPhone }}</p>
          <p>{{ texts.contactEmail }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { localeState } from "@/utils/locale";
import officeImage from "@/assets/01271e5de85b9ca8012138534e001d.jpg";

export default {
  name: "AboutUsPage",
  data() {
    return {
      officeImage,
      copy: {
        zh: {
          hero: {
            title: "做跨境用山西鸿茂贸易有限公司",
            desc: "以一站式跨境电商运营管理系统，助力卖家轻松实现业务增长。",
            alt: "山西鸿茂贸易有限公司办公室",
          },
          companyTitle: "关于山西鸿茂贸易有限公司",
          companyDesc1: "公司创立于 2017 年，专注为跨境电商卖家提供精细化运营和业财一体化解决方案，让跨境电商经营更简单。",
          companyDesc2: "我们围绕订单、库存、财务、广告、品牌分析和组织协作等场景，帮助团队构建更高效的日常管理体系。",
          stats: [
            { value: "TOP 1", label: "行业市占率领先" },
            { value: "500000+", label: "跨境企业的共同选择" },
            { value: "20+", label: "服务中心" },
            { value: "100+", label: "服务上市 / IPO 阶段企业" },
          ],
          productTitle: "产品介绍",
          productDesc: "为跨境电商企业提供供应链、运营、广告和数据分析的一体化解决方案。",
          products: [
            { title: "业财一体化管理", desc: "洞察业务数据变化，支持利润、订单和经营结果的一体化分析。", href: "/#/product/detail", link: "查看产品" },
            { title: "高效管理亚马逊广告", desc: "统一管理广告投放策略、预算和效果分析，提升广告回报。", href: "/#/ad/detail", link: "查看广告方案" },
            { title: "品牌与运营协同", desc: "通过品牌分析、经营报表和合规流程支持团队长期增长。", href: "/#/brand-analytics/detail", link: "查看品牌分析" },
          ],
          valueTitle: "价值观与愿景",
          values: [
            { title: "价值观", desc: "客户第一，简单、极致、创新。" },
            { title: "愿景", desc: "成为值得长期信赖的跨境 SaaS 服务伙伴。" },
            { title: "使命", desc: "让跨境电商经营更简单、更高效、更可持续。" },
          ],
          contactTitle: "联系我们",
          contactAddress: "山西总部：山西省太原市小店区体育南路交通小区8号楼一单元1101",
          contactPhone: "电话：17835276624",
          contactEmail: "邮箱：17835276624@163.com",
        },
        en: {
          hero: {
            title: "Choose Hunan Panxian for Cross-Border Growth",
            desc: "Use a one-stop cross-border e-commerce operating system to help seller teams grow with less friction.",
            alt: "Hunan Panxian office",
          },
          companyTitle: "About Hunan Panxian Intelligent Technology Co., Ltd.",
          companyDesc1: "Founded in 2017, we focus on refined operations and integrated finance-operations solutions for cross-border e-commerce sellers, making daily management simpler.",
          companyDesc2: "Across orders, inventory, finance, advertising, brand analytics, and organizational collaboration, we help teams build a more efficient operating system.",
          stats: [
            { value: "TOP 1", label: "Leading market presence" },
            { value: "500000+", label: "A common choice for cross-border businesses" },
            { value: "20+", label: "Service centers" },
            { value: "100+", label: "Public / IPO-stage clients served" },
          ],
          productTitle: "Our Solutions",
          productDesc: "Integrated solutions for supply chain operations, finance, advertising, and data-driven management for cross-border e-commerce teams.",
          products: [
            { title: "Integrated Finance and Operations", desc: "Analyze profit, orders, and business performance in one management layer.", href: "/#/product/detail", link: "View product" },
            { title: "Efficient Amazon Advertising", desc: "Centralize advertising strategy, budget control, and performance analysis.", href: "/#/ad/detail", link: "View advertising" },
            { title: "Brand and Operations Collaboration", desc: "Support long-term growth with brand analytics, reporting, and compliance workflows.", href: "/#/brand-analytics/detail", link: "View brand analytics" },
          ],
          valueTitle: "Values and Vision",
          values: [
            { title: "Values", desc: "Customer first, simplicity, excellence, and innovation." },
            { title: "Vision", desc: "Become a long-term trusted SaaS partner for cross-border commerce." },
            { title: "Mission", desc: "Make cross-border e-commerce operations simpler, faster, and more sustainable." },
          ],
          contactTitle: "Contact Us",
          contactAddress: "Changsha Headquarters: 17F, Building A-1, Media Art Park, 601 Dongfanghong North Road, High-tech Zone, Changsha",
          contactPhone: "Phone: 17835276624",
          contactEmail: "Email: 17835276624@163.com",
        },
      },
    };
  },
  computed: {
    locale() {
      return localeState.locale;
    },
    texts() {
      return this.copy[this.locale] || this.copy.zh;
    },
  },
};
</script>

<style scoped>
.about-page {
  background: #f5f8ff;
  min-height: 100%;
  padding-bottom: 4rem;
}
.hero {
  background: #fff;
  padding: 3rem 1.25rem 2rem;
}
.container {
  margin: 0 auto;
  max-width: 80rem;
}
.hero-grid,
.stats-grid,
.product-grid,
.value-grid {
  display: grid;
  gap: 1.25rem;
}
.hero-grid {
  align-items: center;
}
.eyebrow {
  font-size: 0.875rem;
  letter-spacing: 0.12em;
  margin-bottom: 0.75rem;
  color: #2554fe;
  text-transform: uppercase;
}
h1 {
  color: #1f2a44;
  font-size: 2.4rem;
  line-height: 1.25;
  margin: 0;
}
.lead,
.section-header p,
.about-card p,
.product-card p,
.value-card p,
.contact-card p,
.stat-item span {
  color: #667085;
  line-height: 1.85;
}
.lead {
  font-size: 1.05rem;
  margin: 1rem 0 0;
  max-width: 32rem;
}
.hero-image {
  border-radius: 1.5rem;
  width: 100%;
}
.content {
  padding: 0 1.25rem;
}
.about-card,
.product-card,
.value-card,
.contact-card {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 18px 48px rgba(28, 65, 148, 0.12);
}
.about-card,
.contact-card {
  margin-top: 1.25rem;
  padding: 1.5rem;
}
.section-header {
  padding: 2.5rem 0 1rem;
  text-align: center;
}
.section-header.left {
  padding: 0 0 1rem;
  text-align: left;
}
.section-header h2,
.about-card h2,
.contact-card h2 {
  color: #173169;
  font-size: 2rem;
  margin: 0 0 0.75rem;
}
.stats-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.stat-item {
  background: #f7faff;
  border: 1px solid #d8e5ff;
  border-radius: 0.875rem;
  padding: 1rem;
}
.stat-item strong {
  color: #2554fe;
  display: block;
  font-size: 1.5rem;
  margin-bottom: 0.35rem;
}
.product-grid,
.value-grid {
  gap: 1rem;
}
.product-card,
.value-card {
  padding: 1.5rem;
}
.product-card h3,
.value-card h3 {
  color: #173169;
  margin: 0 0 0.5rem;
}
.product-card a {
  color: #2554fe;
  display: inline-block;
  margin-top: 0.9rem;
  text-decoration: none;
}
@media (min-width: 1024px) {
  .hero {
    padding: 4rem 2rem 2.5rem;
  }
  .hero-grid {
    grid-template-columns: minmax(0, 1fr) minmax(420px, 0.95fr);
  }
  .stats-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .product-grid,
  .value-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .about-card,
  .contact-card,
  .product-card,
  .value-card {
    padding: 2rem;
  }
}
</style>
